import BulkAssign from './BulkAssign';

export default BulkAssign;
